// WizardStepContent.jsx

import React from 'react';

// CSS
import './WizardStepContent.css';

/**
 * WizardStepContent
 *
 * Scrollable content area for a single wizard step.
 *
 * @param {ReactNode} children - Step body content.
 * @param {boolean} isAutoHeight - Whether the step uses auto height instead of flex fill.
 *
 * @returns {ReactNode} The rendered step content container.
 */
const WizardStepContent = ({ children, isAutoHeight }) => {
    const style = isAutoHeight ? { overflowY: 'visible', flexGrow: 0 } : {};

    // ----- RENDER ----- //

    return <div className="wizard-step-content-container" style={style}>{children}</div>;
};

// Dev Tools
WizardStepContent.displayName = 'WizardStepContent';

export default WizardStepContent;
